export default __webpack_public_path__ + "static/media/INFO_ICON.0b79a427.svg";